import React from 'react';

import PDF from "./PDFComponent";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as tableActions from '../../../store/actions/table';
import PublicPDF from "./PublicPDFComponent";


const PDFPage = (props) => {

    const roundNumber = props.match.params.round ? parseInt(props.match.params.round) : 4;
    const judgeNumber = props.match.params.judge ? parseInt(props.match.params.judge) - 1 : 0;

    const events = props.events;
    if (!events) return null;
    const event = events.event;
    const round = events.competition.template.rounds["1"];
    var scores = round.scores[judgeNumber];


    let grade = events.competition.competition.grade;
    let comp = events.competition.competition;

    let ageTitle = '';

    for(var col of grade.columns){
        if (col.id.toString() === comp.column) {
            ageTitle = col.title;
        }
    }

    const competitionName = events.competition.competition.grade.title + " | " +
        events.competition.competition.rowTitle + " | " +
        ageTitle;
    const code = events.competition.competition.code;

    const titles = [
        event.name,
        code,
        competitionName
    ]

    const headers = [
        "Rank",
        "Dancer #",
        "Name",
        "School",

    ]

    //console.log("Scores", scores);
    let rankField;
    let tiedField;
    if (roundNumber < 4) {
        rankField = "round" + roundNumber + "Rank";
        tiedField = "judgeRound" + roundNumber + "Tied";
    } else {
        rankField = "finalRank";
        tiedField = "tied";
    }

    // If this is round 1 or 2 in a split comp, we need to calculate round rank ourselves, because the scoring engine does not currently save this
    if (events.competition.competition.grade.scoring.judge_rotation_type === 'SPLIT' && roundNumber <= 2 ) {
        // Copied from event controller
        let scoreField = "round" + roundNumber + "Score";
        let placementCounter = 0;
        let lastScore = -1;
        let tiedArray = [];

        // Since 'judgeRound2Tied' for split comps means that the judge's 2 round combined score was a tie, we need to avoid this field
        tiedField = "round" + roundNumber + "Tied";

        // Sort by this round's score
        scores = scores.sort((a, b) => {
            return b[scoreField] - a[scoreField];
        });

        for(let scoreObj of scores) {
            const thisScore = scoreObj[scoreField];
            if (thisScore === lastScore) {
                // We have a tie, add this and previous index (if necessary) to the tiedArray
                if (tiedArray.indexOf(placementCounter - 1) < 0) {      // Add previous index first so numbers are in ascending order
                    tiedArray.push(placementCounter - 1);
                }
                tiedArray.push(placementCounter);
            } 
            
            // Standard case (also applies if this value is continuing a tie streak but this is the last entry)
            if((thisScore !== lastScore) || (placementCounter + 1 === scores.length)) {
                // Check if there is data in the tiedArray (i.e. we have a tie to resolve)
                if (tiedArray.length > 0) {
                    // Get placement from first object
                    const curPlacement  = scores[tiedArray[0]][rankField];
                    for(let x of tiedArray) {
                        // Set placement and tied info on each object
                        scores[x][rankField] = curPlacement;
                        scores[x].tiedCount = tiedArray.length;
                        scores[x][tiedField] = true;
                    }
                }

                // If we just sorted out a tie involving this record and this is the last record, we do not need to set placement
                if (tiedArray.length === 0 || placementCounter + 1 !== scores.length || tiedArray.indexOf(placementCounter) < 0) {
                    // This is either a standalone score, or the first in a set of tied placements
                    scoreObj[rankField] = placementCounter + 1;
                }

                // Reset tiedArray
                tiedArray = [];
            }
            lastScore = thisScore;
            placementCounter++;
        }
  
    }

    scores = scores.sort((a, b) => {
        return a[rankField] - b[rankField];
    });

    if (scores.length > 5) {
        // If there are more than 5 dancers, the report should only show half the dancers (rounded up)
        // The maxDancerRank is important because multiple dancers can be tied for the final spot, in which case we show them all
        let maxDancerRank = Math.ceil(scores.length / 2);
        for (let x = scores.length - 1; x >= 0; x-- ) {
            if (scores[x][rankField] > maxDancerRank) {
                scores = scores.slice(0, x);
            }
        }
    }

    console.log("Scores", scores);

    if (roundNumber === 4) {
        scores = scores.filter(item => item.placed);
    }
    console.log("Scores", scores);

    var content = [];

    let chunks = [];
    var i,j, temporary, chunk2 = 20;
    for (i = 0,j = scores.length; i < j; i += chunk2) {
        temporary = scores.slice(i, i + chunk2);
        chunks.push(temporary);
    }

    let tables = [];

    for(var chunk of chunks) {
        var content2 = chunk.map((score, i) => {
            let rel = events.competition.entries.filter(item => item._id === score.entryCompetition);
            let s = {};

            if (rel.length > 0) {
                s = rel[0];
            }

            let rankString = score[rankField] + (score[tiedField] ? 'T' : '');
            return [
                rankString,
                s.dancerNumber ? s.dancerNumber : 0,
                s.dancer ? s.dancer.name + " " + (s.dancer.lname ? s.dancer.lname : "") : "",
                s.dancer ? s.dancer.school.name : "",

            ]
        });

        tables.push({
            headers,
            content: content2
        });
    }

    const table = {
        headers,
        content
    }

    let judgeNames;
    if (roundNumber === 4) {
        judgeNames = props.events.competition.template.rounds["1"].judges.filter(item => item.name).map(item => item.name + " " + item.lname);
    } else {
        judgeNames = [props.events.competition.template.rounds[roundNumber.toString()].judges[judgeNumber].name + " " + 
        props.events.competition.template.rounds[roundNumber.toString()].judges[judgeNumber].lname];
    }
    const pdfData = { 
        table,
        tables,
        titles,
        judges: judgeNames,
        image: props.events.competition.competition.grade.event.image.path,
    }

    return (
        <div style={{ height: "100vh" }}>

            <PublicPDF pdfData={pdfData} />
        </div>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    user: state.user,
    events: state.events
});


const mapDispatchToProps = dispatch => ({
    getTableData: (view, skip, limit, sort, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
    },
    getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
    },
});


const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFPage));

class PDFPageContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default PDFPageContainer;
